module.exports = __webpack_public_path__ + "img/case_bottom_news_001.1abbe564.png";